<template>
	<div class="turn-system-import">
		<div class="breadcrumb">
			<a-breadcrumb>
				<a-breadcrumb-item>
					<router-link to="/home">首页</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>
					<router-link to="/turn/user">总控设置</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>
					<router-link to="/turn/user">用户管理</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>导入用户</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="turn-system-import-content">
			<div class="import-upload-container">
				<div class="title">温馨提示：</div>
				<div class="tip-message">
					<div>1、只做新增导入，如需更新已存在的成员，请在列表修改。</div>
					<div>2、用户名、真实姓名、手机号均为必填项，且用户名、手机号、邮箱均做重复性判断。</div>
					<div>3、请先到总控设置-角色管理先添加好，再到excel里填入，多角色用英文的“,”隔开</div>
					<div>4、请先到总控设置-组织架构设置先添加好，再到excel里填入，上下级组织间用‘/’隔开，且从最上级组织开始，例如“医院/上海儿童医学中心”</div>
				</div>
				<div class="down-import">
					<a-steps direction="vertical">
						<a-step status="process">
							<div class="title-div" style="margin-bottom:80px;" slot="title">
								<span>下载用户模板，批量添加用户</span>
								<a-button
										@click="downTemplete"
										style="width:82px;margin-left:50px;"
										type="primary"
								>下载
								</a-button>
							</div>
						</a-step>
						<a-step status="process">
							<div class="title-div" style="margin-bottom:50px;" slot="title">
								<span>上传填写好的成员信息</span>
								<a-upload
										name="file"
										:multiple="false"
										:beforeUpload="beforeUpload"
										:showUploadList="false"
								>
									<a-button style="width:82px;margin-left:50px;" type="primary">选择文件</a-button>
								</a-upload>
								<div v-if="fileData" class="file-list">
									<div class="file-li">
										<span>{{fileData.name}}</span>
										<span @click="handleRemove" class="close">
                      <a-icon type="close"/>
                    </span>
									</div>
								</div>
							</div>
						</a-step>
						<a-step v-if="fileData" status="process">
							<div class="title-div" slot="title">
								<span>点击提交</span>
								<a-button
										@click="handleUpload"
										style="width:82px;margin-left:50px;"
										type="primary"
								>提交
								</a-button>
							</div>
						</a-step>
					</a-steps>
				</div>
			</div>
			<div v-if="importResult" class="import-histry">
				<!-- <div class="title">最近导入（最近半年记录）</div> -->
				<div class="title">导入结果</div>
				<div v-for="item in 1" :key="item" class="histry-group">
					<div class="header">
						<i class="iconfont icon-yonghu"></i>
						<span class="desc">{{importResult.importTime}}</span>
						<div class="desc-value">成功导入{{importResult.successNum}}位成员，失败{{importResult.errNum}}位成员</div>
					</div>
					<div v-if="importResult.errList" class="table">
						<a-table
								class="hospital-table"
								:pagination="false"
								:locale="{emptyText:'暂无数据'}"
								:columns="columns"
								:dataSource="importResult.errList"
								size="middle"
						></a-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  const columns = [
    {
      title: "行数",
      // customRender: (text, record, index) => `${index + 1}`
      dataIndex: "excelNo"
    },
    {
      title: "用户名",
      dataIndex: "username"
    },
    {
      title: "真实姓名",
      dataIndex: "nickName"
    },
    {
      title: "手机号",
      dataIndex: "mobile"
    },
    {
      title: "邮箱",
      dataIndex: "email"
    },
    {
      title: "组织",
      dataIndex: "deptName"
    },
    {
      title: "角色",
      dataIndex: "roleName"
    },
    {
      title: "失败原因",
      dataIndex: "errorReason"
    }
  ];
  export default {
    data() {
      return {
        columns,
        uploadFile: null,
        headers: {
          authorization: this.$store.state.account.token
        },
        fileData: null,
        importResult: null,
        beforeUpload: (file, fileList) => {
          this.fileData = file;
          return false;
        }
      };
    },
    mounted() {
      this.uploadFile = this.$db.get("uploadFile");
    },
    methods: {
      downTemplete() {
        if (this.uploadFile.userImportExcelTemplate) {
          window.open(this.uploadFile.userImportExcelTemplate);
        }
      },
      handleRemove() {
        this.fileData = null;
      },
      handleUpload(info) {
        const formData = new FormData();
        this.importResult = null;
        formData.append("file", this.fileData);
        this.$upload("fileupload/upload", formData).then(
          res => {
            this.$get("user/excel/import", {
              filePath: this.uploadFile.fileHost + res.data.data.certifJpgFile
            }).then(resObj => {
              this.importResult = resObj.data.data;
            });
            this.fileData = null;
          },
          err => {
          }
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
	.turn-system-import {
		.turn-system-import-content {
			background: #fff;
			padding-top: 30px;
			.import-histry {
				padding: 40px 34px;
				.histry-group + .histry-group {
					margin-top: 30px;
				}
				.histry-group {
					.table {
						margin-top: 20px;
					}
					.header {
						.icon-yonghu {
							font-size: 20px;
							color: #428ef7;
						}
						.desc {
							font-size: 14px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(164, 164, 164, 1);
							margin-left: 10px;
						}
						.desc-value {
							font-size: 14px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(51, 51, 51, 1);
							margin-left: 30px;
						}
					}
				}
			}
			.title {
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
				margin-bottom: 10px;
			}
			.import-upload-container {
				padding: 0 34px 40px;
				border-bottom: 1px solid #f0f2f5;

				.down-import {
					margin-top: 30px;
					.title-div {
						.file-list {
							.file-li {
								padding: 0 15px;
								height: 30px;
								line-height: 30px;
								margin-top: 18px;
								background: rgba(249, 252, 255, 1);
								border-radius: 2px;
								font-size: 12px;
								font-family: PingFang SC;
								font-weight: 400;
								color: rgba(66, 142, 247, 1);
								.close {
									float: right;
									cursor: pointer;
								}
							}
						}
					}
				}
				.tip-message {
					width: 100%;
					background: rgba(249, 251, 251, 1);
					border: 1px solid rgba(240, 242, 245, 1);
					padding: 20px;
					div {
						font-size: 13px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(164, 164, 164, 1);
						line-height: 24px;
					}
				}
			}
		}
	}
</style>